import { Component, computed, inject, output, Renderer2 } from '@angular/core';
import { input } from '@angular/core';
import { outputFromObservable, toSignal } from '@angular/core/rxjs-interop';
import { ATTRIBUTES } from '@constants/attributes';
import { FREQUENCY_PAYLOAD, INTERCONNECTORS_PAYLOAD, REGIONS_PAYLOAD } from '@constants/payloads';
import { FiltersService } from '@services/filters/filters.service';
import { map } from 'rxjs';
import { Service } from 'src/app/shared/registries/methods-services';
import { fixScroll } from '../../util';

// Templates HTML importés (assurez-vous que vos loaders Webpack les gèrent toujours bien)
// @ts-ignore
import DATE_RANGE_TEMPLATE from '@assets/tooltip-infos/date-range-info.html';
// @ts-ignore
import INTERCONNECTOR_INFO_TEMPLATE from '@assets/tooltip-infos/interconnectors-info.html';
// @ts-ignore
import NET_INTERCONNECTOR_INFO_TEMPLATE from '@assets/tooltip-infos/net-interconnectors-info.html';
// @ts-ignore
import STATIONS_DATE_TEMPLATE from '@assets/tooltip-infos/stations-date-info.html';

@Component({
  selector: 'nem-filters',
  templateUrl: './filters.comp.html',
  standalone: false
})
export class FiltersComponent {
  // Injection de dépendances moderne (Angular 14+)
  filterService = inject(FiltersService);
  private _renderer = inject(Renderer2);

  // 1. SIGNAL INPUTS
  showInterconnectorsInfo = input<boolean>(true);
  showRangeInfo = input<boolean>(true);
  loading = input<boolean>(false);
  layoutDirection = input<'vertical' | 'horizontal'>('horizontal');

  // 2. SIGNAL OUTPUTS (Angular 19)
  filtersChange = outputFromObservable(this.filterService.query_fg.valueChanges);
  filtersOnSubmit = output();

  // 3. COMPUTED SIGNALS (Remplacent les anciens getters très gourmands)
  filtersToShow = computed(() => ATTRIBUTES[this.filterService.currentService]);

  showNetInterconnectorsInfo = computed(() => this.filterService.currentService === Service.REGIONAL);

  isHorizontalLayout = computed(() => this.layoutDirection() === 'horizontal');

  // Classes CSS calculées dynamiquement
  containerClass = computed(() => {
    return this.isHorizontalLayout()
      ? 'flex flex-wrap items-end gap-3 p-4 bg-white dark:bg-[#16142b] rounded-xl border border-slate-200 dark:border-slate-800 shadow-sm mb-6 transition-colors duration-300'
      : 'flex flex-col gap-5 p-5 bg-white dark:bg-[#16142b] rounded-xl border border-slate-200 dark:border-slate-800 shadow-sm transition-colors duration-300';
  });

  // 4. TRANSFORMATION RXJS -> SIGNALS (Fini les | async dans le HTML)
  stationOptions = toSignal(this.filterService.stationResponse$.pipe(map(res => res.stations)), { initialValue: [] });

  stationDates = toSignal(this.filterService.stationResponse$.pipe(map(res => res.stations_dates)), {
    initialValue: null
  });

  // 5. CONSTANTES LOCALES
  stationsDateInfo = STATIONS_DATE_TEMPLATE;
  regions = REGIONS_PAYLOAD;
  interConnectors = INTERCONNECTORS_PAYLOAD;
  dataFrequency = FREQUENCY_PAYLOAD;
  dateRangeInfo = DATE_RANGE_TEMPLATE;
  interconnectorsInfo = INTERCONNECTOR_INFO_TEMPLATE;
  netInterconnectorsInfo = NET_INTERCONNECTOR_INFO_TEMPLATE;

  // 6. MÉTHODES
  regionsOnChange() {
    this.filterService.updateOnRegionsChanges();
  }

  stationsOnChange({ originalEvent }: { originalEvent?: Event }) {
    this.filterService.updateAggrByFuelSource();
    originalEvent?.stopPropagation();
  }

  isSelected(name: string) {
    return this.filterService.isSelected(name);
  }

  filtersSubmit(ev: any) {
    if (ev) {
      this.filtersOnSubmit.emit();
    }
  }

  fixbodyscroll(evt: 'onshow' | 'onhide', name: string) {
    fixScroll(evt, this._renderer, name);
  }
}
